import ApiService from './apiService';
import type { IOptionsCalculatorConfig } from '../models/IOptionsCalculatorConfig';
import { type TPandasTable } from '../models/TPandasTable';
import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type PlotlyResponse } from '../models/PlotlyModel';

export default class SvCalculatorServices extends ApiService {
  static async getOptionsTable(configuration?: IOptionsCalculatorConfig, factsheetId?: string) {
    return await super.get<TPandasTable>(EDjangoAppsEndpoints.calculator, 'table', {
      ...configuration,
      derivatives: configuration?.derivatives?.join(','),
      factsheetId
    });
  }

  static async getOptionsTableDerivatives(configuration?: IOptionsCalculatorConfig, factsheetId?: string) {
    return await super.get<{ options: Array<{label: string, value: string}> }>(EDjangoAppsEndpoints.calculator, 'table/derivatives', {
      ...configuration,
      factsheetId
    });
  }

  static async getPlot2d(configuration?: IOptionsCalculatorConfig, factsheetId?: string) {
    return await super.get<{ put: PlotlyResponse; call: PlotlyResponse }>(EDjangoAppsEndpoints.calculator, '2d-plot', {
      ...configuration,
      plotY: configuration?.plotY?.join(','),
      factsheetId
    });
  }

  static async getPlot3d(configuration?: IOptionsCalculatorConfig, factsheetId?: string) {
    return await super.get<{ put: PlotlyResponse; call: PlotlyResponse }>(EDjangoAppsEndpoints.calculator, '3d-plot', {
      ...configuration,
      factsheetId
    });
  }

  static async getPlotSimulation(configuration?: IOptionsCalculatorConfig, factsheetId?: string) {
    return await super.get<{ put: PlotlyResponse; put_payoff: number; call: PlotlyResponse; call_payoff: number }>(
      EDjangoAppsEndpoints.calculator,
      'simulation',
      { ...configuration, factsheetId }
    );
  }

  static async authGetOptionsTable(configuration?: IOptionsCalculatorConfig) {
    return await super.get<TPandasTable>(EDjangoAppsEndpoints.calculator, 'auth/table', {
      ...configuration,
      derivatives: configuration?.derivatives?.join(',')
    });
  }

  static async authGetOptionsTableDerivatives(configuration?: IOptionsCalculatorConfig) {
    return await super.get<{ options: Array<{label: string, value: string}> }>(EDjangoAppsEndpoints.calculator, 'auth/table/derivatives', {
      ...configuration
    });
  }

  static async authGetPlot2d(configuration?: IOptionsCalculatorConfig) {
    return await super.get<{ put: PlotlyResponse; call: PlotlyResponse }>(EDjangoAppsEndpoints.calculator, 'auth/2d-plot', {
      ...configuration,
      plotY: configuration?.plotY?.join(','),
    });
  }

  static async authGetPlot3d(configuration?: IOptionsCalculatorConfig) {
    return await super.get<{ put: PlotlyResponse; call: PlotlyResponse }>(EDjangoAppsEndpoints.calculator, 'auth/3d-plot', {
      ...configuration,
    });
  }

  static async authGetPlotSimulation(configuration?: IOptionsCalculatorConfig) {
    return await super.get<{ put: PlotlyResponse; put_payoff: number; call: PlotlyResponse; call_payoff: number }>(
      EDjangoAppsEndpoints.calculator,
      'auth/simulation',
      { ...configuration }
    );
  }
}
